import type { ReactElement } from 'react'
import styles from './SkeletonRow.module.css'

/**
 * One skeleton placeholder row shown in the `loading` state — a 28×28
 * circle plus two grey bars (title 180×14, subtitle 110×10).
 *
 * Figma node 6176:15850 (SkeletonRow). Purely decorative — `aria-hidden`.
 */
export function SkeletonRow(): ReactElement {
  return (
    <div className={styles.row} aria-hidden>
      <span className={styles.icon} />
      <span className={styles.labels}>
        <span className={styles.titleBar} />
        <span className={styles.subtitleBar} />
      </span>
    </div>
  )
}
